(()=>{
  const q=(s,c=document)=>c.querySelector(s), qa=(s,c=document)=>[...c.querySelectorAll(s)];
  const body=document.body;

  const loader=q('[data-lux-loader]');
  const hideLoader=()=>{ if(!loader)return; window.setTimeout(()=>loader.classList.add('is-hidden'),350); };
  if(document.readyState==='complete') hideLoader(); else window.addEventListener('load',hideLoader,{once:true});
  window.setTimeout(hideLoader,2400);

  const menu=q('[data-lux-menu]'), search=q('[data-lux-search]');
  const menuPrimary=q('[data-menu-primary]',menu), menuCollections=q('[data-menu-collections-panel]',menu);
  function resetMenuPanels(){
    menu?.classList.remove('is-collections-open');
    menuPrimary?.setAttribute('aria-hidden','false');
    menuCollections?.setAttribute('aria-hidden','true');
  }
  function openOverlay(el){ if(!el)return; el.classList.add('is-open'); el.setAttribute('aria-hidden','false'); body.classList.add('is-overlay-open'); if(el===menu) resetMenuPanels(); }
  function closeOverlay(el){ if(!el)return; el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); if(el===menu) resetMenuPanels(); if(!q('.lux-menu.is-open,.lux-search.is-open')) body.classList.remove('is-overlay-open'); }
  q('[data-menu-open]')?.addEventListener('click',()=>openOverlay(menu));
  q('[data-menu-close]')?.addEventListener('click',()=>closeOverlay(menu));
  q('[data-search-open]')?.addEventListener('click',()=>{openOverlay(search);setTimeout(()=>q('[data-search-field]')?.focus(),350)});
  q('[data-search-close]')?.addEventListener('click',()=>closeOverlay(search));
  qa('.lux-menu__nav a').forEach(a=>a.addEventListener('click',()=>closeOverlay(menu)));
  q('[data-menu-collections-open]')?.addEventListener('click',()=>{ menu?.classList.add('is-collections-open'); menuPrimary?.setAttribute('aria-hidden','true'); menuCollections?.setAttribute('aria-hidden','false'); });
  q('[data-menu-collections-close]')?.addEventListener('click',()=>resetMenuPanels());
  qa('.lux-menu-card').forEach(a=>a.addEventListener('click',()=>closeOverlay(menu)));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeOverlay(menu);closeOverlay(search)}});

  // Shopify Theme Editor-safe reveal handling.
  // Sections are re-rendered live when an image/video setting changes. Newly injected
  // [data-reveal] nodes must be re-initialized or they remain at opacity:0.
  const isThemeEditor=!!(window.Shopify && window.Shopify.designMode);
  if(isThemeEditor) body.classList.add('is-theme-editor');

  const io=(!isThemeEditor && 'IntersectionObserver' in window)
    ? new IntersectionObserver(entries=>entries.forEach(e=>{
        if(e.isIntersecting){
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      }),{threshold:.12,rootMargin:'0px 0px -7%'})
    : null;

  function initReveals(scope=document){
    qa('[data-reveal]',scope).forEach(el=>{
      if(isThemeEditor || !io){
        el.classList.add('is-visible');
      }else if(!el.classList.contains('is-visible')){
        io.observe(el);
      }
    });
  }
  initReveals();

  let parallax=qa('[data-parallax]');
  let ticking=false;
  function refreshParallax(){ parallax=qa('[data-parallax]'); }
  function updateParallax(){
    const h=innerHeight;
    parallax.forEach(w=>{
      const media=q('img,video,.lux-flex-media',w);
      if(!media)return;
      const r=w.getBoundingClientRect();
      if(r.bottom<0||r.top>h)return;
      // In the theme editor keep media stable while settings are being changed.
      if(isThemeEditor){ media.style.removeProperty('transform'); return; }
      const p=(r.top+r.height/2-h/2)/h;
      media.style.transform=`scale(1.04) translate3d(0,${p*-18}px,0)`;
    });
    ticking=false;
  }
  addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(updateParallax);ticking=true}},{passive:true});
  updateParallax();

  // Shopify emits these after a section/block is replaced or selected in the editor.
  // Re-activate reveal/media behavior so content never disappears after choosing media.
  document.addEventListener('shopify:section:load',event=>{
    initReveals(event.target || document);
    refreshParallax();
    requestAnimationFrame(updateParallax);
  });
  document.addEventListener('shopify:section:select',event=>{
    initReveals(event.target || document);
  });
  document.addEventListener('shopify:block:select',event=>{
    initReveals(event.target || document);
  });

  // Desktop collection scroll story: pin one media scene and swap content as the page scrolls.
  const scrollStories=qa('[data-vc-scroll-story]');
  const desktopStoryMQ=window.matchMedia('(min-width: 901px)');
  let storyTicking=false;
  function clamp(n,min,max){return Math.min(max,Math.max(min,n))}
  function updateScrollStories(){
    if(!desktopStoryMQ.matches){
      scrollStories.forEach(story=>{
        story.style.removeProperty('--vc-scroll-progress');
        story.classList.remove('is-products');
        qa('[data-vc-scroll-step]',story).forEach((step,i)=>step.classList.toggle('is-active',i===0));
      });
      storyTicking=false;
      return;
    }
    const vh=window.innerHeight || document.documentElement.clientHeight;
    scrollStories.forEach(story=>{
      const rect=story.getBoundingClientRect();
      const distance=Math.max(1,story.offsetHeight-vh);
      const progress=clamp((-rect.top)/distance,0,1);
      story.style.setProperty('--vc-scroll-progress',progress.toFixed(4));

      // Three visual chapters: collection story, watches 1–3, watches 4–5 + discover.
      const active=progress < .31 ? 0 : (progress < .66 ? 1 : 2);
      qa('[data-vc-scroll-step]',story).forEach(step=>{
        step.classList.toggle('is-active',Number(step.dataset.vcScrollStep)===active);
      });
      story.classList.toggle('is-products',active>0);
    });
    storyTicking=false;
  }
  function requestStoryUpdate(){
    if(!storyTicking){storyTicking=true;requestAnimationFrame(updateScrollStories)}
  }
  if(scrollStories.length){
    addEventListener('scroll',requestStoryUpdate,{passive:true});
    addEventListener('resize',requestStoryUpdate,{passive:true});
    desktopStoryMQ.addEventListener?.('change',requestStoryUpdate);
    updateScrollStories();
  }


  // Collection video pause/play control used by the desktop split-screen scene.
  qa('[data-vc-video-toggle]').forEach(button=>{
    const scene=button.closest('[data-vc-split-story]');
    const video=scene ? q('video.vc-split-story__video',scene) : null;
    if(!video) return;
    button.addEventListener('click',()=>{
      if(video.paused){
        const p=video.play(); if(p&&p.catch) p.catch(()=>{});
        button.classList.remove('is-paused');
        button.setAttribute('aria-label','Pause video');
        button.setAttribute('aria-pressed','false');
      }else{
        video.pause();
        button.classList.add('is-paused');
        button.setAttribute('aria-label','Play video');
        button.setAttribute('aria-pressed','true');
      }
    });
  });


  // V22 — fixed desktop stage with vertical slide transitions.
  // The video and watch viewport remain pinned. Only the active collection layer
  // slides upward while the next collection enters from below in the same frame.
  const masterStories=qa('[data-vc-master-story]');
  const masterStoryMQ=window.matchMedia('(min-width: 901px)');
  let masterStoryTicking=false;
  const masterStoryState=new WeakMap();

  function setMasterLayerState(story,active,immediate=false){
    const count=Math.max(1,Number(story.dataset.vcMasterCount)||1);
    const next=Math.max(0,Math.min(count-1,active));
    if(immediate) story.classList.add('vc-master-no-transition');

    qa('[data-vc-master-layer]',story).forEach(layer=>{
      const index=Number(layer.dataset.vcMasterLayer)||0;
      layer.classList.remove('is-current','is-before','is-after','is-active');
      if(index<next) layer.classList.add('is-before');
      else if(index>next) layer.classList.add('is-after');
      else layer.classList.add('is-current','is-active');
      layer.style.removeProperty('visibility');
      layer.style.removeProperty('z-index');
      if(layer instanceof HTMLElement) layer.setAttribute('aria-hidden',index===next?'false':'true');
    });

    story.dataset.vcActive=String(next);
    masterStoryState.set(story,next);

    if(immediate){
      story.getBoundingClientRect();
      requestAnimationFrame(()=>story.classList.remove('vc-master-no-transition'));
    }
  }

  function updateMasterVideoButton(story,activeIndex){
    const button=q('[data-vc-master-video-toggle]',story);
    if(!button)return;
    const activeLayer=qa('.vc-master-story__media-layer',story).find(layer=>(Number(layer.dataset.vcMasterLayer)||0)===activeIndex);
    const activeVideo=activeLayer?q('video',activeLayer):null;
    button.hidden=!activeVideo;
    const paused=story.dataset.vcMasterUserPaused==='true';
    button.classList.toggle('is-paused',paused);
    button.setAttribute('aria-label',paused?'Play video':'Pause video');
    button.setAttribute('aria-pressed',paused?'true':'false');
  }

  function syncMasterVideos(story,opacities,activeIndex){
    const pausedByUser=story.dataset.vcMasterUserPaused==='true';
    qa('.vc-master-story__media-layer',story).forEach(layer=>{
      const index=Number(layer.dataset.vcMasterLayer)||0;
      const video=q('video',layer);
      if(!video)return;
      const shouldPlay=!pausedByUser && (opacities[index]||0)>.02;
      if(shouldPlay && video.paused){
        const p=video.play();
        if(p&&p.catch)p.catch(()=>{});
      }else if(!shouldPlay && !video.paused){
        video.pause();
      }
    });
    updateMasterVideoButton(story,activeIndex);
  }

  function updateMasterStories(){
    if(!masterStoryMQ.matches){
      masterStories.forEach(story=>setMasterLayerState(story,0,true));
      masterStoryTicking=false;
      return;
    }

    const vh=window.innerHeight || document.documentElement.clientHeight;
    masterStories.forEach(story=>{
      const count=Math.max(1,Number(story.dataset.vcMasterCount)||1);
      const rect=story.getBoundingClientRect();
      const distance=Math.max(1,story.offsetHeight-vh);
      const progress=clamp((-rect.top)/distance,0,1);
      const position=count>1 ? progress*(count-1) : 0;
      const base=Math.min(count-1,Math.floor(position));
      const phase=base>=count-1 ? 0 : position-base;
      // Stable hold -> short transition -> stable lock on the next collection.
      const fadeStart=.35;
      const fadeEnd=.55;
      const fade=base>=count-1 ? 0 : clamp((phase-fadeStart)/(fadeEnd-fadeStart),0,1);
      const active=Math.max(0,Math.min(count-1,base+(fade>=.5?1:0)));
      const opacities=Array(count).fill(0);

      opacities[base]=1-fade;
      if(base+1<count) opacities[base+1]=fade;
      if(base===count-1) opacities[base]=1;

      qa('[data-vc-master-layer]',story).forEach(layer=>{
        const index=Number(layer.dataset.vcMasterLayer)||0;
        const opacity=opacities[index]||0;
        let y=0;
        if(index===base) y=-22*fade;
        else if(index===base+1) y=22*(1-fade);
        else y=index<base?-22:22;

        layer.style.setProperty('--vc-layer-opacity',opacity.toFixed(3));
        layer.style.setProperty('--vc-layer-y',`${y.toFixed(1)}px`);
        layer.style.setProperty('--vc-panel-scale',(0.992+(opacity*.008)).toFixed(4));
        layer.style.setProperty('--vc-media-scale',(1.022-(opacity*.022)).toFixed(4));
      });

      story.style.setProperty('--vc-master-progress',progress.toFixed(4));
      story.style.setProperty('--vc-master-position',position.toFixed(4));

      const current=masterStoryState.get(story);
      if(typeof current!=='number') setMasterLayerState(story,active,true);
      else if(current!==active){
        story.dataset.vcDirection=active>current?'down':'up';
        setMasterLayerState(story,active,false);
      }
      syncMasterVideos(story,opacities,active);
    });
    masterStoryTicking=false;
  }

  function requestMasterStoryUpdate(){
    if(!masterStoryTicking){masterStoryTicking=true;requestAnimationFrame(updateMasterStories)}
  }

  let masterSnapTimer=0;
  function settleMasterStories(){
    if(!masterStoryMQ.matches)return;
    const vh=window.innerHeight || document.documentElement.clientHeight;

    masterStories.forEach(story=>{
      const count=Math.max(1,Number(story.dataset.vcMasterCount)||1);
      if(count<2)return;

      const rect=story.getBoundingClientRect();
      if(rect.bottom<=0 || rect.top>=vh)return;

      const distance=Math.max(1,story.offsetHeight-vh);
      const progress=clamp((-rect.top)/distance,0,1);
      const position=progress*(count-1);
      const base=Math.min(count-1,Math.floor(position));
      if(base>=count-1)return;

      const phase=position-base;
      const fadeStart=.35;
      const fadeEnd=.55;

      // Only "catch" the page if the user stopped inside the crossfade.
      if(phase<fadeStart-.03 || phase>fadeEnd+.03)return;

      const fade=clamp((phase-fadeStart)/(fadeEnd-fadeStart),0,1);
      const targetIndex=fade<.5 ? base : base+1;
      const targetProgress=targetIndex/(count-1);
      const storyTop=window.scrollY+rect.top;
      const targetY=storyTop+(targetProgress*distance);

      window.scrollTo({
        top:Math.max(0,targetY),
        behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'
      });
    });
  }

  function requestMasterStorySettle(){
    clearTimeout(masterSnapTimer);
    masterSnapTimer=setTimeout(settleMasterStories,140);
  }

  if(masterStories.length){
    addEventListener('scroll',()=>{
      requestMasterStoryUpdate();
      requestMasterStorySettle();
    },{passive:true});
    addEventListener('resize',requestMasterStoryUpdate,{passive:true});
    masterStoryMQ.addEventListener?.('change',requestMasterStoryUpdate);
    updateMasterStories();
  }

  qa('[data-vc-master-video-toggle]').forEach(button=>{
    const scene=button.closest('[data-vc-master-story]');
    if(!scene)return;
    button.addEventListener('click',()=>{
      const paused=scene.dataset.vcMasterUserPaused==='true';
      scene.dataset.vcMasterUserPaused=paused?'false':'true';
      requestMasterStoryUpdate();
    });
  });


  // V8 — transition from the final collection grid into a fullscreen cinematic chapter.
  const finales=qa('[data-vc-finale]');
  let finaleTicking=false;
  function updateFinales(){
    const vh=window.innerHeight || document.documentElement.clientHeight;
    finales.forEach(finale=>{
      const rect=finale.getBoundingClientRect();
      const takeover=clamp((vh-rect.top)/(vh*.9),0,1);
      const clip=(1-takeover)*7, clipX=(1-takeover)*10, scale=1.075-(takeover*.075);
      const copy=clamp((takeover-.28)/.48,0,1), copyY=(1-copy)*34;
      finale.style.setProperty('--vc-finale-progress',takeover.toFixed(4));
      finale.style.setProperty('--vc-finale-clip',`${clip.toFixed(2)}%`);
      finale.style.setProperty('--vc-finale-clip-x',`${clipX.toFixed(2)}%`);
      finale.style.setProperty('--vc-finale-scale',scale.toFixed(4));
      finale.style.setProperty('--vc-finale-copy-opacity',copy.toFixed(3));
      finale.style.setProperty('--vc-finale-copy-y',`${copyY.toFixed(1)}px`);
    });
    finaleTicking=false;
  }
  function requestFinaleUpdate(){if(!finaleTicking){finaleTicking=true;requestAnimationFrame(updateFinales)}}
  if(finales.length){addEventListener('scroll',requestFinaleUpdate,{passive:true});addEventListener('resize',requestFinaleUpdate,{passive:true});updateFinales()}
  qa('[data-vc-finale-video-toggle]').forEach(button=>{
    const finale=button.closest('[data-vc-finale]'), video=finale?q('.vc-finale__video',finale):null;
    if(!video)return;
    button.addEventListener('click',()=>{
      if(video.paused){const p=video.play();if(p&&p.catch)p.catch(()=>{});button.classList.remove('is-paused');button.setAttribute('aria-label','Pause video');button.setAttribute('aria-pressed','false')}
      else{video.pause();button.classList.add('is-paused');button.setAttribute('aria-label','Play video');button.setAttribute('aria-pressed','true')}
    });
  });

  qa('[data-watch-rail]').forEach(rail=>{
    let down=false,start=0,left=0;
    rail.addEventListener('pointerdown',e=>{if(e.target.closest('button,a,input,select,textarea'))return;down=true;start=e.clientX;left=rail.scrollLeft;rail.setPointerCapture?.(e.pointerId)});
    rail.addEventListener('pointermove',e=>{if(!down)return;rail.scrollLeft=left-(e.clientX-start)});
    ['pointerup','pointercancel','pointerleave'].forEach(ev=>rail.addEventListener(ev,()=>down=false));
  });

  qa('[data-spec-tab]').forEach(btn=>btn.addEventListener('click',()=>{
    const key=btn.dataset.specTab;
    const scope=btn.closest('.ap26-tabs,.ap2-specs,.ap-specs') || document;
    qa('[data-spec-tab]',scope).forEach(b=>{const active=b===btn;b.classList.toggle('is-active',active);b.setAttribute('aria-selected',active?'true':'false');b.tabIndex=active?0:-1});
    qa('[data-spec-panel]',scope).forEach(panel=>panel.classList.toggle('is-active',panel.dataset.specPanel===key));
  }));

  const fav=q('[data-favourite]');
  if(fav){
    const key='lux_favourites_v1', id=fav.dataset.productId;
    const read=()=>{try{return JSON.parse(localStorage.getItem(key)||'[]')}catch(e){return[]}};
    const sync=()=>fav.classList.toggle('is-saved',read().includes(id)); sync();
    fav.addEventListener('click',()=>{let a=read();a=a.includes(id)?a.filter(x=>x!==id):[...a,id];try{localStorage.setItem(key,JSON.stringify(a))}catch(e){}sync()});
  }

  qa('[data-calibre-visual]').forEach(scope=>{
    const button=q('[data-calibre-toggle]',scope);
    const images=qa('[data-calibre-image]',scope);
    if(!button || images.length<2) return;
    button.addEventListener('click',()=>{
      const current=q('.ap26-calibre-image.is-active',scope) || images[0];
      const next=images.find(img=>img!==current) || images[0];
      images.forEach(img=>img.classList.remove('is-active'));
      next.classList.add('is-active');
      const label=q('span',button);
      if(label){
        label.textContent = next.dataset.calibreImage==='front' ? 'Switch to back' : 'Switch to front';
      }
    });
  });

  // V40 — AP related watches horizontal carousel controls.
  qa('[data-ap-related-carousel]').forEach(scope=>{
    const rail=q('[data-ap-related-rail]',scope);
    const prev=q('[data-ap-related-prev]',scope);
    const next=q('[data-ap-related-next]',scope);
    if(!rail || !prev || !next)return;

    const step=()=>{
      const card=q('.ap-related__card',rail);
      if(!card)return Math.max(280,rail.clientWidth*.78);
      const gap=parseFloat(getComputedStyle(rail).columnGap||getComputedStyle(rail).gap||'8')||8;
      return card.getBoundingClientRect().width+gap;
    };
    const sync=()=>{
      const max=Math.max(0,rail.scrollWidth-rail.clientWidth);
      prev.disabled=rail.scrollLeft<=4;
      next.disabled=rail.scrollLeft>=max-4;
    };
    prev.addEventListener('click',()=>rail.scrollBy({left:-step(),behavior:'smooth'}));
    next.addEventListener('click',()=>rail.scrollBy({left:step(),behavior:'smooth'}));
    rail.addEventListener('scroll',()=>requestAnimationFrame(sync),{passive:true});
    addEventListener('resize',sync,{passive:true});
    sync();
  });


  // V43 — craftsmanship carousel.
  qa('[data-ap26-craft]').forEach(scope=>{
    const rail=q('[data-ap26-craft-rail]',scope);
    const prev=q('[data-ap26-craft-prev]',scope);
    const next=q('[data-ap26-craft-next]',scope);
    if(!rail || !prev || !next)return;
    const step=()=>{
      const item=q('.ap26-craft__item',rail);
      if(!item)return Math.max(320,rail.clientWidth*.48);
      const style=getComputedStyle(rail);
      const gap=parseFloat(style.columnGap||style.gap||'8')||8;
      return item.getBoundingClientRect().width+gap;
    };
    const sync=()=>{
      const max=Math.max(0,rail.scrollWidth-rail.clientWidth);
      prev.disabled=rail.scrollLeft<=4;
      next.disabled=rail.scrollLeft>=max-4;
    };
    prev.addEventListener('click',()=>rail.scrollBy({left:-step(),behavior:'smooth'}));
    next.addEventListener('click',()=>rail.scrollBy({left:step(),behavior:'smooth'}));
    rail.addEventListener('scroll',()=>requestAnimationFrame(sync),{passive:true});
    addEventListener('resize',sync,{passive:true});
    sync();
  });


  // V49 — Infinite Vibrations carousel.
  qa('[data-ap26-light-story]').forEach(scope=>{
    const rail=q('[data-ap26-light-rail]',scope);
    const prev=q('[data-ap26-light-prev]',scope);
    const next=q('[data-ap26-light-next]',scope);
    if(!rail || !prev || !next)return;
    const step=()=>{
      const item=q('.ap26-light-story__item',rail);
      if(!item)return Math.max(320,rail.clientWidth*.45);
      const style=getComputedStyle(rail);
      const gap=parseFloat(style.columnGap||style.gap||'8')||8;
      return item.getBoundingClientRect().width+gap;
    };
    const sync=()=>{
      const max=Math.max(0,rail.scrollWidth-rail.clientWidth);
      prev.disabled=rail.scrollLeft<=4;
      next.disabled=rail.scrollLeft>=max-4;
    };
    prev.addEventListener('click',()=>rail.scrollBy({left:-step(),behavior:'smooth'}));
    next.addEventListener('click',()=>rail.scrollBy({left:step(),behavior:'smooth'}));
    rail.addEventListener('scroll',()=>requestAnimationFrame(sync),{passive:true});
    addEventListener('resize',sync,{passive:true});
    sync();
  });


  // V51 — UP CLOSE horizontal carousel.
  qa('[data-ap26-up-close-carousel]').forEach(scope=>{
    const rail=q('[data-ap26-up-close-rail]',scope);
    const prev=q('[data-ap26-up-close-prev]',scope);
    const next=q('[data-ap26-up-close-next]',scope);
    if(!rail || !prev || !next)return;

    const step=()=>{
      const item=q('.ap26-up-close__item',rail);
      if(!item)return Math.max(300,rail.clientWidth*.45);
      const style=getComputedStyle(rail);
      const gap=parseFloat(style.columnGap||style.gap||'10')||10;
      return item.getBoundingClientRect().width+gap;
    };

    const sync=()=>{
      const max=Math.max(0,rail.scrollWidth-rail.clientWidth);
      prev.disabled=rail.scrollLeft<=4;
      next.disabled=rail.scrollLeft>=max-4;
    };

    prev.addEventListener('click',()=>rail.scrollBy({left:-step(),behavior:'smooth'}));
    next.addEventListener('click',()=>rail.scrollBy({left:step(),behavior:'smooth'}));
    rail.addEventListener('scroll',()=>requestAnimationFrame(sync),{passive:true});
    addEventListener('resize',sync,{passive:true});
    sync();
  });


})();

document.querySelectorAll('.ap26-tabs').forEach((scope,i)=>{const tabs=[...scope.querySelectorAll('[role=tab]')];tabs.forEach((tab,j)=>{tab.id='reference-tab-'+i+'-'+j;tab.tabIndex=j===0?0:-1;const panel=scope.querySelector('[data-spec-panel="'+tab.dataset.specTab+'"]');if(panel){panel.id='reference-panel-'+i+'-'+j;panel.setAttribute('aria-labelledby',tab.id);tab.setAttribute('aria-controls',panel.id)}tab.addEventListener('keydown',e=>{let n=j;if(e.key==='ArrowRight')n=(j+1)%tabs.length;else if(e.key==='ArrowLeft')n=(j-1+tabs.length)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();tabs[n].click();tabs[n].focus()})})});

if(!customElements.get('reference-rail'))customElements.define('reference-rail',class extends HTMLElement{
connectedCallback(){requestAnimationFrame(()=>{if(this.ready)return;const track=this.querySelector('.rf-rail__track');if(!track)return;this.ready=true;
const prev=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]');
const update=()=>{if(prev)prev.disabled=track.scrollLeft<2;if(next)next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};
const move=direction=>{const first=track.querySelector('figure');track.scrollBy({left:direction*((first?.getBoundingClientRect().width||track.clientWidth)+10),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});
track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});
this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(track);update()})}
disconnectedCallback(){this.resizeObserver?.disconnect()}
});
if(!customElements.get('reference-calibre'))customElements.define('reference-calibre',class extends HTMLElement{
connectedCallback(){requestAnimationFrame(()=>{if(this.ready)return;const images=[...this.querySelectorAll('img')],button=this.querySelector('button');if(images.length<2||!button)return;this.ready=true;let front=false;images[1].hidden=true;button.addEventListener('click',()=>{front=!front;images[0].hidden=front;images[1].hidden=!front;button.textContent=front?'Switch to back':'Switch to front'})})}
});


/* RELUXE DRAG SCROLL */
(()=>{
  const SELECTORS=[
    '.ra-collection-rail',
    '[data-ap-related-rail]',
    '.ro-close__rail',
    '.ro-related__grid',
    '.rf-rail__track',
    '[data-ap26-craft-rail]',
    '[data-ap26-light-rail]',
    '[data-ap26-up-close-rail]'
  ].join(',');

  const ensureStyle=()=>{
    if(document.getElementById('reluxe-drag-scroll-style'))return;
    const style=document.createElement('style');
    style.id='reluxe-drag-scroll-style';
    style.textContent=`
      .reluxe-drag-scroll{
        cursor:grab;
        overscroll-behavior-x:contain;
        -webkit-overflow-scrolling:touch;
        scrollbar-width:none;
      }
      .reluxe-drag-scroll::-webkit-scrollbar{display:none}
      .reluxe-drag-scroll.is-dragging{
        cursor:grabbing!important;
        scroll-behavior:auto!important;
        scroll-snap-type:none!important;
      }
      .reluxe-drag-scroll.is-dragging,
      .reluxe-drag-scroll.is-dragging *{
        user-select:none!important;
        -webkit-user-select:none!important;
      }
    `;
    document.head.appendChild(style);
  };

  const bind=(rail)=>{
    if(rail.dataset.reluxeDragBound==='true')return;
    rail.dataset.reluxeDragBound='true';

    let active=false;
    let moved=false;
    let suppressClick=false;
    let startX=0;
    let startScroll=0;
    let pointerId=null;

    const sync=()=>{
      const canScroll=rail.scrollWidth>rail.clientWidth+3;
      rail.classList.toggle('reluxe-drag-scroll',canScroll);
    };

    const end=(e)=>{
      if(!active)return;
      active=false;
      suppressClick=moved;
      rail.classList.remove('is-dragging');
      if(pointerId!==null){
        try{rail.releasePointerCapture?.(pointerId)}catch(_){}
      }
      pointerId=null;
      if(e?.pointerType==='mouse') rail.style.removeProperty('scroll-behavior');
    };

    rail.addEventListener('pointerdown',(e)=>{
      if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('button,input,select,textarea')||rail.scrollWidth<=rail.clientWidth+3)return;
      active=true;
      moved=false;
      pointerId=e.pointerId;
      startX=e.clientX;
      startScroll=rail.scrollLeft;
    });

    rail.addEventListener('pointermove',(e)=>{
      if(!active||e.pointerId!==pointerId)return;
      const dx=e.clientX-startX;
      if(!moved&&Math.abs(dx)>5){
        moved=true;
        rail.setPointerCapture?.(e.pointerId);
        rail.classList.add('is-dragging');
      }
      if(!moved)return;
      e.preventDefault();
      rail.scrollLeft=startScroll-dx;
    });

    ['pointerup','pointercancel'].forEach(type=>rail.addEventListener(type,end));
    rail.addEventListener('lostpointercapture',end);

    rail.addEventListener('click',(e)=>{
      if(!suppressClick)return;
      suppressClick=false;
      e.preventDefault();
      e.stopPropagation();
    },true);

    rail.addEventListener('dragstart',(e)=>{
      if(active)e.preventDefault();
    });

    const ro=new ResizeObserver(sync);
    ro.observe(rail);
    rail._reluxeDragResizeObserver=ro;
    sync();
  };

  const init=(root=document)=>{
    ensureStyle();
    root.querySelectorAll?.(SELECTORS).forEach(bind);
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();

  document.addEventListener('shopify:section:load',(e)=>init(e.target));
})();

// Small, progressively enhanced cart controls on every watch card and product.
document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('[data-la-cart-form], .rx-form')) return;
  event.preventDefault();
  if (form.dataset.cartBusy === 'true') return;
  const button = form.querySelector('[name="add"]');
  if (!button || button.disabled) return;
  const status = form.querySelector('.la-cart-status');
  const view = form.querySelector('.la-mini-cart__view');
  const original = button.innerHTML;
  const compact = form.matches('[data-la-cart-form]');
  const originalTitle = button.title;
  const originalAriaLabel = button.getAttribute('aria-label');
  clearTimeout(button._laAddedTimeout);
  let added = false;
  form.dataset.cartBusy = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (status) {status.hidden = compact; status.textContent = 'Adicionando…';}
  if (compact) button.innerHTML = '<span aria-hidden="true">…</span>';
  if (view) view.hidden = true;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
    const item = await response.json();
    if (!response.ok) throw new Error(typeof item.description === 'string' ? item.description : 'Não foi possível adicionar. Tente novamente.');
    added = true;
    if (status) {status.textContent = 'Adicionado ao carrinho'; status.hidden = compact;}
    if (view) view.hidden = true;
    button.classList.add('is-added');
    button.title = 'Adicionado ao carrinho';
    button.setAttribute('aria-label', 'Adicionado ao carrinho. Adicionar outra unidade: ' + (item.product_title || item.title || 'relógio'));
    document.dispatchEvent(new CustomEvent('cart:updated', {detail:{item}}));
    try {
    const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
    if (cartResponse.ok) {
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      document.querySelectorAll('.rx-cart-link').forEach(el => el.textContent = 'Ver carrinho (' + cart.item_count + ')');
    }
    } catch (badgeError) { /* The watch has already been added. */ }
  } catch(error) {
    if (status) {status.hidden = false; status.textContent = error.message || 'Não foi possível adicionar. Tente novamente.';}
  } finally {
    form.dataset.cartBusy = 'false';
    button.disabled = form.matches('.rx-form') ? form.querySelector('[data-rx-variant]')?.selectedOptions[0]?.dataset.available === 'false' : false;
    button.removeAttribute('aria-busy');
    button.innerHTML = added ? (compact ? '<span aria-hidden="true">✓</span>' : '✓ Adicionado ao carrinho') : original;
    if (added && compact) {
      button._laAddedTimeout = setTimeout(() => {
        button.innerHTML = original;
        button.classList.remove('is-added');
        button.title = originalTitle;
        if (originalAriaLabel) button.setAttribute('aria-label', originalAriaLabel);
      }, 1600);
    }
  }
});
